import React, {useState} from 'react';

import {ArrowDownward as ArrowDownIcon, ArrowUpward as ArrowUpIcon} from '@mui/icons-material';
import {
    Box,
    Button,
    Stack} from '@mui/material';
import {useMediaQuery, useTheme} from '@mui/material';

import {Drawer, Text} from 'components';
// import {imageUrl} from 'lib/media';
import {useSettingsStore} from 'module/settings/zustand';
import {useLayoutStore} from 'store';

import Lineup from './Lineup';

const styles = {
    drawer: {
        position: 'absolute',
        top: {
            desktop: '130px',
            mobile: '100px'
        },
        bottom: 0,
        left: 0,
        width: 'auto',
        maxWidth: '180px',
        display: 'flex',
        flexDirection: 'column',
        background: '#333',
        overflowY: 'scroll !important',
        overflowX: 'hidden !important',
        height: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#666',
            borderRadius: '8px',
            border: '2px solid transparent',
            backgroundClip: 'padding-box',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#666',
            backgroundClip: 'padding-box',
        },
    },
    drawerInvisible: {
        opacity: 0,
    },
    iconBox: {
        width: '100%',
        marginBottom: '8px',
        borderRadius: '8px',
        overflow: 'hidden',
        '&:hover': {
        }
    },
    icon: {
        height: '80px',
        overflow: 'hidden',
    },
    buttonInvisible: {
        opacity: 0.6,
    },
    toggleButton: theme => ({
        width: '100%',
        padding: '16px !important',
        color: theme.palette.lineup.textPrimary,
        background: theme.palette.grey.darker,
        overflow: 'hidden',
        position: 'relative',
        textTransform: 'none',
        fontWeight: '400',
        borderRadius: '8px',
        fontSize: '14px',
        opacity: '1',
        transition: 'none',
        '&:first-of-type': {
            marginBottom: '8px',
        },
        '&.Mui-disabled': {
            color: `${theme.palette.green.lineup} !important`,
            opacity: '1 !important',
        },
        '&:hover': {
            background: theme.palette.grey.darker,
        },
    }),
    toggleButtonSelected: theme => ({
        color: theme.palette.green.lineup,
        background: theme.palette.lineup.buttonBgSelected,
        '&:hover': {
            background: theme.palette.grey.darker,
        },
    }),
    avatar: theme => ({
        height: 24,
        width: 24,
        marginRight: '10px',
        border: `2px solid ${theme.palette.lineup.avatarBorder}`,
    }),
    playerDisabled: theme => ({
        opacity: theme.palette.lineup.playerDisabled,
        filter: 'grayscale(0.5)',
        overflow: 'hidden',
    }),
    playerShirt: {
        overflow: 'hidden',
        position: 'relative',
        '& span': {
            textAlign: 'center',
            position: 'absolute',
            top: 40,
            left: 0,
            width: '100%',
            fontWeight: '700',
        }
    },
    lineUpContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: '0',
    },
    playerCircleContainer: {
        cursor: 'grab',
        '&:hover': {
        },
        '&:active': {
            cursor: 'grabbing',
        }
    },
    headerSection: {
        padding: '8px 8px 16px 8px',
    },
};

const LineupTool = () => {
    const [type, setType] = useState('home');
    const theme = useTheme();
    // const selectedTeam = useSettingsStore((state) => state.selectedTeam);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // const selectedClient = useSettingsStore(state => state.selectedClient);
    // const selectedEnemyClient = useSettingsStore(state => state.selectedEnemyClient);

    const showLineup = useLayoutStore((state) => state.showLineup);
    const setShowLineup = useLayoutStore((state) => state.setShowLineup);
    const lineupIsDragging = useLayoutStore((state) => state.lineupIsDragging);
    const lineupDirection = useSettingsStore((state) => state.lineupDirection);

    const doClose = () => {
        setShowLineup(false);
    };

    const onChange = (v) => {
        console.log('onChange', v);
        if (v !== null) {
            setType(v);
        }
    };

    return (
        <Drawer
            open={showLineup} 
            onClose={doClose} 
            sx={{
                ...styles.drawer,
                ...((lineupIsDragging && isMobile) && styles.drawerInvisible)
            }}
            slotProps={{backdrop: {invisible: true}}}>
            
            <>
                <Stack 
                    direction="column"
                    alignItems="center" 
                    gap={0}
                    justifyContent={'center'}
                    sx={styles.headerSection}>
                    <Button 
                        disableRipple
                        disableFocusRipple
                        disabled={type === 'home' && true}
                        onClick={() => onChange('home')}
                        sx={{
                            ...styles.toggleButton(theme), 
                            ...(type === 'home' && styles.toggleButtonSelected(theme)), 
                            ...((lineupIsDragging) && styles.buttonInvisible)
                        }}>
                        {/* <Avatar
                                sx={styles.avatar(theme)} 
                                alt={selectedClient?.name} 
                                src={imageUrl(selectedClient?.image, {w: 100, h: 100})}>
                                {selectedClient?.name?.substring(0, 2)}
                            </Avatar> */}
                        <Text>board.lineup.my_team</Text>
                        {lineupDirection === 'up' ? 
                            <ArrowUpIcon sx={{ml: 1, color: type === 'home' ? 'inherit' : theme.palette.lineup.textMuted}} /> : 
                            <ArrowDownIcon sx={{ml: 1, color: type === 'home' ? 'inherit' : theme.palette.lineup.textMuted}} />
                        }
                    </Button>
                    <Button 
                        disableRipple
                        disableFocusRipple
                        disabled={type === 'guest' && true}
                        onClick={() => onChange('guest')}
                        sx={{
                            ...styles.toggleButton(theme), 
                            ...(type === 'guest' && styles.toggleButtonSelected(theme)), 
                            ...((lineupIsDragging) && styles.buttonInvisible)
                        }}>
                        {/* <Avatar
                                sx={styles.avatar(theme)} 
                                alt={selectedEnemyClient?.name} 
                                src={imageUrl(selectedEnemyClient?.image, {w: 100, h: 100})}>
                                {selectedEnemyClient?.name?.substring(0, 2)}
                            </Avatar> */}
                        <Text>board.lineup.opponent</Text>
                        {lineupDirection === 'up' ? 
                            <ArrowDownIcon sx={{ml: 1, color: type === 'guest' ? 'inherit' : theme.palette.lineup.textMuted}} /> : 
                            <ArrowUpIcon sx={{ml: 1, color: type === 'guest' ? 'inherit' : theme.palette.lineup.textMuted}} />
                        }
                    </Button>
                </Stack>
                    
                <Box sx={styles.lineUpContainer}>
                    <Lineup type={type} />
                </Box>
            </>
        </Drawer>
    );
};

export default LineupTool;